/** Human-readable labels for SurfaceContext publishers (Chat Panel scope). */

export function dashboardSurfaceSummary(pathname: string): string {
  if (pathname.includes('/domain/business')) return 'Business domain';
  if (pathname.includes('/products') && !pathname.includes('/product/')) return 'Products overview';
  if (pathname.includes('/product/') && pathname.includes('/pipeline')) return 'Product pipeline';
  if (pathname.includes('/product/') && pathname.includes('/operations')) return 'Product operations';
  if (pathname.includes('/product/') && pathname.includes('/development')) return 'Product development';
  if (pathname.includes('/product/') && pathname.includes('/projections')) return 'Product projections';
  if (pathname.includes('/product/') && pathname.includes('/marketfit')) return 'Market fit';
  if (pathname.includes('/stakeholders')) return 'Stakeholders';
  if (pathname.includes('/customers')) return 'Customers';
  if (pathname.includes('/objective/')) return 'Objective';
  if (pathname.includes('/bridge-card')) return 'Bridge card';
  if (pathname.match(/\/product\/[^/]+$/)) return 'Product overview';
  return 'Dashboard';
}

export function companyArtifactsViewLabel(view: string): string {
  switch (view) {
    case 'workflow':
      return 'Workflow';
    case 'processes':
      return 'Processes';
    case 'bootstrap':
      return 'Bootstrap tracking';
    default:
      return 'Artifact tree';
  }
}
